<template>
  <v-dialog v-model="showGroupDialog" persistent max-width="600px">
    <v-card>
      <v-card-title class="primary">
        <span class="headline white--text">Add Group</span>
      </v-card-title>

      <v-card-text class="pb-0">
        <v-container>
          <v-row>
            <v-col cols="12" class="px-1 pb-0">
              <v-text-field
                data-cy="note-field"
                label="Name"
                required
                v-model="group.name"
              ></v-text-field>
            </v-col>
            <v-col cols="12" lg="4" md="4" sm="12" class="px-1 pb-0">
              <v-text-field
                data-cy="note-field"
                label="Customer Number"
                required
                v-model="group.customerNumber"
              ></v-text-field>
            </v-col>
            <v-col cols="12" lg="4" md="4" sm="12" class="px-1 pb-0">
              <v-text-field
                data-cy="note-field"
                label="Number"
                required
                v-model="group.number"
              ></v-text-field>
            </v-col>
            <v-col cols="12" lg="4" md="4" sm="12" class="px-1 pb-0">
              <v-select
                v-model="group.payTerm"
                :items="[14, 30]"
                label="Payment Term"
                required
              ></v-select>
            </v-col>
            <v-col cols="12" lg="4" md="4" sm="12" class="px-1 pb-0">
              <v-checkbox
                v-model="group.inclusionStatus"
                label="Include"
              ></v-checkbox>
            </v-col>

            <v-col cols="12" lg="4" md="4" sm="12" class="px-1 pb-0">
              <v-checkbox
                v-model="group.isWholesaler"
                label="Wholesaler"
              ></v-checkbox>
            </v-col>
          </v-row>

          <v-row style="background-color: #f7f7f7" class="px-3 pb-4">
            <v-col cols="12" class="px-1 pb-0 title">Stage</v-col>

            <v-col
              cols="12"
              lg="3"
              md="4"
              sm="12"
              class="px-1 pb-0 pt-5"
              style="font-size: 16px"
            >
              Courtesy
            </v-col>
            <v-col cols="12" lg="9" md="8" sm="12" class="px-1 pb-0 pt-0">
              <span class="test" style="width: 500px">
                <v-switch
                  label="Exclude"
                  @click.stop=""
                  inset
                  hide-details
                  class="mt-3"
                  v-model="group.notice.courtesy"
                ></v-switch>
              </span>
            </v-col>

            <v-col
              cols="12"
              lg="3"
              md="4"
              sm="12"
              class="px-1 pb-0 pt-5"
              style="font-size: 16px"
            >
              Reminder 1
            </v-col>
            <v-col cols="12" lg="9" md="4" sm="12" class="px-1 pb-0 pt-0">
              <v-switch
                label="Exclude"
                @click.stop=""
                inset
                hide-details
                class="mt-3"
                v-model="group.notice.reminder1"
              ></v-switch>
            </v-col>

            <v-col
              cols="12"
              lg="3"
              md="4"
              sm="12"
              class="px-1 pb-0 pt-5"
              style="font-size: 16px"
            >
              Reminder 2
            </v-col>
            <v-col cols="12" lg="9" md="4" sm="12" class="px-1 pb-0 pt-0">
              <v-switch
                label="Exclude"
                @click.stop=""
                inset
                hide-details
                class="mt-3"
                v-model="group.notice.reminder2"
              ></v-switch>
            </v-col>

            <v-col
              cols="12"
              lg="3"
              md="4"
              sm="12"
              class="px-1 pb-0 pt-5"
              style="font-size: 16px"
            >
              Reminder 3
            </v-col>
            <v-col cols="12" lg="9" md="4" sm="12" class="px-1 pb-0 pt-0">
              <v-switch
                label="Exclude"
                @click.stop=""
                inset
                hide-details
                class="mt-3"
                v-model="group.notice.reminder3"
              ></v-switch>
            </v-col>

            <v-col
              cols="12"
              lg="3"
              md="4"
              sm="12"
              class="px-1 pb-0 pt-5"
              style="font-size: 16px"
            >
              Restrict Notice
            </v-col>
            <v-col cols="12" lg="9" md="4" sm="12" class="px-1 pb-0 pt-0">
              <v-switch
                label="Exclude"
                @click.stop=""
                inset
                hide-details
                class="mt-3"
                v-model="group.notice.restrictNotice"
              ></v-switch>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions class="pb-7 pr-7">
        <v-spacer></v-spacer>
        <v-btn
          data-cy="save"
          color="blue darken-1"
          class="primary"
          @click="upsertGroup"
          >Submit</v-btn
        >
        <v-btn color="blue darken-1" class="primary" @click="hideDialog()"
          >Cancel</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ReminderGroup from "@/models/ReminderGroup";

export default {
  data: function () {
    return {
      nameContent: "",
      hasName: true,
      showDialog: "",
      load: true,
      group: new ReminderGroup(),
    };
  },
  computed: {
    ...mapGetters("groups", ["showGroupDialog"]),
  },
  methods: {
    ...mapActions("groups", ["addExcludedGroup"]),
    ...mapActions("reminders", ["updateExcludeStatus", "loadExcludedGroups"]),
    upsertGroup() {
      this.$store.dispatch("groups/upsertGroup", this.group).then(() => {
        this.group = new ReminderGroup();
        this.hideDialog(true);
        this.$emit("load");
      });
    },
    submitName() {
      let name = [];
      let type = 0;
      name.name = this.nameContent;
      name.customerNumber = 0;
      if (!name.name) {
        this.hasName = false;
        return false;
      }
      this.updateExcludeStatus(name, type).then((data) => {
        this.$emit("load");
        this.hasName = true;
        this.hideDialog(true);
        this.nameContent = "";
        this.name = [];
      });
    },
    hideDialog() {
      this.group = new ReminderGroup();
      this.addExcludedGroup();
    },
    checkNameValue() {
      this.hasName = this.nameContent;
    },
  },
};
</script>
